import { render } from "./PwpHeader.vue?vue&type=template&id=915b8e16&scoped=true"
import script from "./PwpHeader.vue?vue&type=script&lang=js"
export * from "./PwpHeader.vue?vue&type=script&lang=js"

import "./PwpHeader.vue?vue&type=style&index=0&id=915b8e16&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915b8e16"]])

export default __exports__